import { Typography } from '@material-ui/core'
import { LIMIT_ALL } from '../../../../constants/pagination'
import { useTranslation } from 'react-i18next'
import React, { useState, useCallback, useEffect } from 'react'
import { motion } from 'framer-motion'
import moment from 'moment'

// COMPONENT
import { colors } from '../../../../constants/colors'
import { ButtonContained, ButtonOutlined, ButtonOutlinedDanger } from '../../../../component/mui-custom/MuiCustom'
import { Box, Button, MenuItem, Tabs } from '@mui/material'
import { CustomTab, CustomTabPanel } from '../../../../component/Tabs/TabsCustom'
import { RouteImage } from '../../../../assets/routeImage'
import * as styles from '../../style/main.style'
import Navbar from '../../Navbar'
import Header from '../../Header'
import AlertCustom from '../../../../component/alert/AlertCustom'
import FilterSelect from '../../../../component/select/filterSelect'
import InputDatePicker from '../../../../component/input/inputDatePicker'
import InputTextField from '../../../../component/input/inputTextField'
import LabelCustom from '../../../../component/label/LabelCustom'
import { numberFormat } from '../../../../utils/common'
import FileDragAndDrop from '../../../../component/dragAndDrop/dragAndDrop'
import { notification } from '../../../../constants/notificationMessage'
import { swalError, swalSuccess } from '../../../../component/notification/swal'
import TrackingProcess from './tracking/TrackingProcess'
import FileTracking from './file/FileTracking'
import ImageTracking from './file/ImageTracking'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import TableCustom from '../../../../component/table/tableCustom'



// TYPE
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom'
import { ProjectApi, detailDepartment } from '../../../../api/project/project.api';
import { FiscalYearApi } from '../../../../api/fiscal-year/fiscalyear.api'
import { StrategyApi } from '../../../../api/strategy/strategy.api'
import { TacticsApi, getTactics } from '../../../../api/tactics/tactics.api'
import { PlanApi } from '../../../../api/plan/plan.api'
import { TypesApi } from '../../../../api/type/type.api';
import { ClustersApi } from '../../../../api/clusters/clusters.api'
import { BudgetApi } from '../../../../api/budget/budget.api'
import { EmployeesApi } from '../../../../api/employee/Employees.api'
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../../../component/loading/Loading'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'
import { FilesApi } from '../../../../api/files/files.api';
import ModalCustom from '../../../../component/modal/ModalCustom'

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatCurrencyData, handleTypingNumber, revertFormatCurrency } from '../../../../utils/app.utils'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Swal from 'sweetalert2'
import { DetailAccordion, MainAccordion, TopicAccordion } from '../../../../component/accordion/accordion.custom'
import UploadFile from '../../../../component/upload/UploadFile'
import { importEquipment } from './type/viewTrack.type'
import { notiError } from '../../../../component/notification/notification.alert'
import { fileTypeEnum } from '../../../../utils/enum'
import { statusChecked } from './checkedStatus'
import { notificationSwal } from '../../../../utils/notification.swal'
import Dropdown from '../../../../component/dropdown/Dropdown'
import AutocompleteSelect from '../../../../component/select/autoCompleteSelect'


function projectTabsProps(index: number) {
    return {
        id: `project-tab-${index}`,
        'aria-controls': `project-tabpanel-${index}`,
    };
}

type Props = {}

const EditTrackingProjectStatus = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { idProject } = useParams();
    // const idProject = location.state;
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading)
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [stickyActive, setStickyActive] = useState<boolean>(false)

    const [detailExtension, setDetailExtension] = useState<any[]>([]);
    const [expansionMostEndDate, setExpansionMostEndDate] = useState<Date | string>("");
    const [statusPercent, setStatusPercent] = useState<number>(Number);
    const [dataForCancelProject, setDataForCancelProject] = useState<any>(null)
    const [projectDetail, setProjectDetail] = useState<any>(null)
    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [strategy, setStrategy] = useState<any[]>([]);
    const [tactics, setTactics] = useState<any[]>([]);
    const [plans, setPlans] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);
    const [clusters, setClusters] = useState<any[]>([]);
    const [budget, setBudget] = useState<any[]>([]);
    const [employees, setEmployees] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);
    const [isCreateStatus, setIsCreateStatus] = useState<boolean>(false);
    const [statusId, setStatusId] = useState<number>(Number);
    const [projectStatusCode, setProjectStatusCode] = useState<string>("");
    const [idType, setIdType] = useState<number>(Number);
    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);
    const [idStrategy, setIdStrategy] = useState<number>(Number);
    const [idStatus, setIdStatus] = useState<number>(Number);
    const [isEquipment, setIsEquipment] = useState<boolean>(false);
    const [fileEquipment, setFileEquipment] = useState<importEquipment[]>([]);
    const [projectProgress, setProjectProgress] = useState<any>(null);

    const [isClosed, setIsClosed] = useState<boolean>(false);
    const [isActivity, setIsActivity] = useState<boolean>(false)
    const [indexProcessStatus, setIndexProcessStatus] = useState<number>(Number);

    const handleOnSizeError = (errorText: string) => swalError(errorText)
    const handleOnTypeError = (errorText: string) => swalError(errorText)

    const [projectTabs, setProjectTabs] = useState<number>(0);
    const [isDisbursement, setIsDisbursement] = useState<boolean>(false);

    const handleChangeProjectTabs = (event: React.SyntheticEvent, newValue: number) => setProjectTabs(newValue)

    const [projectTracking, setProjectTracking] = useState<any>({
        detailActivities: [],
        detailProcess: [],
        detailProgress: [],
        detailDisbursement: [],
        sumAllBudget: 0,
        sumAllPaid: 0,
        sumAllUnpaid: 0,
        projectPrinciple: "",
        projectTrack: {
            asPlanComplete: null,
            asPlanCompleteRemark: null,
            dateComplete: null,
            detailFiles: [],
            detailImages: [],
            detailTrackIndicators: [],
            expectedResult: null,
            idTrack: null,
            latitude: null,
            longitude: null,
            problem: null,
            resultLocal: null,
            resultNationalStrategy: null,
            resultOfTargetGroup: null,
            resultOfTargetGroupRemark: null,
            resultOfTargetProductivity: null,
            resultOfTargetProductivityRemark: null,
            resultOfTargetResult: null,
            resultOfTargetResultRemark: null,
            resultStrategyProvince: null,
            resultTargetMain: null,
            resultTargetSub: null,
            suggestions: null,
            summaryResult: null,
            targetGroup: null,
            targetProductivity: null,
            targetResult: null
        }
    })
    // API
    const handleGetDetailProject = async () => {
        dispatch(setLoading())
        await ProjectApi.getDetailTrackingProject(Number(idProject))
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setProjectDetail(res.data?.result)
                    setIdType(res.data?.result?.idType)
                    const data = res.data?.result;
                    // console.log(data)
                    if (data) {
                        setProjectProgress(data?.projectProgress)
                        setDetailExtension([...data?.detailExtension]);
                        setStatusPercent(data?.statusPercent)
                        setIsClosed(!!data?.isClosed)
                        setIdStatus(data?.idStatus)
                        setDataForCancelProject(data)
                        setFileEquipment([...data?.detailEquipment])
                        setIdFiscalYear(data?.idFiscalYear)
                        setIdStrategy(data?.idStrategy)

                        const sumPaidDetailDisbursement = data?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.paid), 0) || 0;
                        // const sumPaidDetailActivities = data?.detailActivities?.reduce((a: any, b: any) =>
                        //     a + (b.detailDisbursement?.reduce((m: any, n: any) => m + Number(n?.paid), 0) || 0), 0) || 0;
                        const sumUnpaidDetailDisbursement = data?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.unpaid), 0) || 0;
                        // const sumUnpaidDetailActivities = data?.detailActivities?.reduce((a: any, b: any) =>
                        //     a + (b.detailDisbursement?.reduce((m: any, n: any) => m + Number(n?.unpaid), 0) || 0), 0) || 0;

                        const totalSumAllPaid = sumPaidDetailDisbursement || 0;
                        const totalSumAllUnpaid = sumUnpaidDetailDisbursement || 0;
                        const totalSumAllBudget = data?.sumAllBudget ? Number(data?.sumAllBudget || 0) : 0;
                        // const totalSumAllBudget = data?.detailBudget?.reduce((a: any, b: any) => a + Number(b?.sumBudget), 0) || 0;
                        // const totalSumAllPaid = sumPaidDetailDisbursement + sumPaidDetailActivities || 0;
                        // const totalSumAllUnpaid = sumUnpaidDetailDisbursement + sumUnpaidDetailActivities || 0;

                        const mainData = {
                            sumAllBudget: formatCurrencyData(totalSumAllBudget.toString(), 'revert'),
                            sumAllPaid: formatCurrencyData(totalSumAllPaid.toString(), 'revert'),
                            sumAllUnpaid: formatCurrencyData(totalSumAllUnpaid.toString(), 'revert'),
                            // sumAllBudget: data?.sumAllBudget ? formatCurrencyData(data?.sumAllBudget || "", 'revert') : formatCurrencyData(totalSumAllBudget.toString(), 'revert'),
                            // sumAllPaid: data?.sumAllPaid ? formatCurrencyData(data?.sumAllPaid || "", 'revert') : formatCurrencyData(totalSumAllPaid.toString(), 'revert'),
                            // sumAllUnpaid: data?.sumAllUnpaid ? formatCurrencyData(data?.sumAllUnpaid || "", 'revert') : formatCurrencyData(totalSumAllUnpaid.toString(), 'revert'),
                            isClosed: data?.isClosed,
                            isDeleted: data?.isDeleted,
                            detailImages: [],
                            detailDisbursement: data?.detailDisbursement?.map((list: any) => {
                                return {
                                    ...list,
                                    budget: formatCurrencyData(list?.budget || "", 'revert'),
                                    paid: formatCurrencyData(list?.paid || "", 'revert'),
                                    unpaid: formatCurrencyData(list?.unpaid || "", 'revert'),
                                }
                            }),
                            detailIndicators: [...data?.detailIndicators],
                            detailProgress: data?.detailProgress?.map((detail: any) => ({
                                ...detail,
                                idFile: detail?.file ? detail?.idFile : 0
                            })),
                            detailResponsible: data?.detailResponsible || [],
                            detailWorkPeriod: [...data?.detailWorkPeriod],
                            detailBudget: data?.detailBudget?.map((list: any) => ({ ...list, sumBudget: formatCurrencyData(list?.sumBudget, 'revert') })),
                            detailProcess: data?.detailProcess?.map((list: any) => ({ ...list, amount: formatCurrencyData(list?.amount || "", 'revert') || undefined })),
                            projectTrack: {
                                ...data?.projectTrack,
                            },
                        }
                        const activityData = data?.detailActivities?.map((list: any) => ({
                            ...list,
                            sumAllBudget: formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y.budget), 0).toString(), 'revert'),
                            sumAllPaid: formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.paid), 0).toString(), 'revert'),
                            sumAllUnpaid: formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.unpaid), 0).toString(), 'revert'),
                            // sumAllBudget: formatCurrencyData(list?.sumAllBudget || "", 'revert') || formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y.budget), 0).toString(), 'revert'),
                            // sumAllPaid: formatCurrencyData(list?.sumAllPaid || "", 'revert') || formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.paid), 0).toString(), 'revert'),
                            // sumAllUnpaid: formatCurrencyData(list?.sumAllUnpaid || "", 'revert') || formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.unpaid), 0).toString(), 'revert'),
                            detailImages: [],
                            detailDisbursement: list?.detailDisbursement?.map((detail: any) => {
                                return {
                                    ...detail,
                                    budget: formatCurrencyData(detail?.budget || "", 'revert'),
                                    paid: formatCurrencyData(detail?.paid || "", 'revert'),
                                    unpaid: formatCurrencyData(detail?.unpaid || "", 'revert'),
                                }
                            }),
                            detailIndicators: [...list?.detailIndicators],
                            detailProgress: list?.detailProgress?.map((detail: any) => ({
                                ...detail,
                                idFile: detail?.file ? detail?.idFile : 0
                            })),
                            detailResponsible: [...list?.detailResponsible],
                            detailWorkPeriod: [...list?.detailWorkPeriod],
                            detailProcess: list?.detailProcess?.map((list: any) => ({ ...list, amount: formatCurrencyData(list?.amount || "", 'revert') || undefined })),
                            projectTrack: {
                                ...list?.projectTrack
                            }
                        }))
                        setProjectTracking((prev: any) => ({
                            ...prev,
                            ...data,
                            tabs: [mainData, ...activityData]
                        }))
                    }


                } else {
                    navigate(-1)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error.response?.description)
            })
    }

    const handleSubmit = async (event: React.FormEvent) => {
        // console.log(projectTracking)
        event.preventDefault();
        const filterValidateImage: boolean = projectTracking?.tabs?.slice(1, projectTracking?.tabs?.length)?.some((list: any) => list?.detailImages?.length === 0 && list?.projectTrack?.detailImages?.length === 0);
        const filterActivityImagesFormApi: boolean = projectTracking?.detailActivities?.some((list: any) => list?.projectTrack?.detailImages?.length === 0);
        // console.log(projectTracking?.tabs?.slice(1, projectTracking?.tabs?.length))
        // console.log(`filterImage ${filterValidateImage} , filterFromApi ${filterActivityImagesFormApi}`)

        // แก้ไข ไม่ required อัพโหลดครุภัณฑ์
        // if (isEquipment === true && fileEquipment?.length === 0) {
        //     swalError('กรุณาอัพโหลดไฟล์ครุภัณฑ์');
        //     return;
        // }
        if (projectTracking?.tabs[0]?.detailImages?.length === 0 && projectTracking?.projectTrack?.detailImages?.length === 0) {
            swalError('กรุณาอัพโหลดรูปภาพอย่างน้อย 1 รูป');
            return;
        }
        if (filterValidateImage && filterActivityImagesFormApi) {
            const filterValidateImage: number = projectTracking?.tabs?.slice(1, projectTracking?.tabs?.length)?.findIndex((list: any) => list?.detailImages?.length === 0 && list?.projectTrack?.detailImages?.length === 0)
            const findIndexImage: number = projectTracking?.detailActivities?.findIndex((result: any) => result?.projectTrack?.detailImages?.length === 0);
            if (filterValidateImage) {
                setProjectTabs(filterValidateImage + 1);
            } else {
                setProjectTabs(findIndexImage + 1);
            }
            // console.log(findIndexImage);
            swalError('กรุณาอัพโหลดรูปภาพกิจกรรมย่อยอย่างน้อย 1 รูป')
            return;
        }

        const detailImagesPromises = projectTracking?.tabs[0]?.detailImages?.map(async (list: any) => {
            dispatch(setLoading());
            const formData = new FormData();
            formData.append('file', list);

            try {
                const res = await FilesApi.createFile(formData);
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    return {
                        idFile: res?.data?.result?.idFile
                    };
                }
            } catch (error) {
                console.log(error);
            }
        });
        const detailFilesPromise = projectTracking?.tabs[0]?.projectTrack?.detailFiles
            ?.filter((list: any) => list?.idFile === undefined)
            .map(async (list: any) => {
                dispatch(setLoading());
                const formData = new FormData();
                formData.append('file', list);

                try {
                    const res = await FilesApi.createFile(formData);
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        return {
                            idFile: res.data?.result?.idFile
                        };
                    }

                } catch (error) {
                    console.log(error);
                }
            });
        const [detailImagesResults, detailFilesResult] = await Promise.all([
            Promise.all(detailImagesPromises || []),
            Promise.all(detailFilesPromise || [])
        ]);
        const dataImage = [...detailImagesResults]
        const dataFile = [...detailFilesResult]
        const filteredDetailImages = projectTracking?.tabs[0]?.projectTrack?.detailImages?.filter((list: any) => Object.keys(list).length !== 0);
        const filteredDetailFiles = projectTracking?.tabs[0]?.projectTrack?.detailFiles?.filter((list: any) => Object.keys(list).length !== 0);

        let condition: any = {
            ...projectTracking,
            sumAllBudget: formatCurrencyData(projectTracking?.tabs[0]?.sumAllBudget, 'convert') || null,
            sumAllPaid: formatCurrencyData(projectTracking?.tabs[0]?.sumAllPaid, 'convert') || null,
            sumAllUnpaid: formatCurrencyData(projectTracking?.tabs[0]?.sumAllUnpaid, 'convert') || null,
            detailEquipment: [...fileEquipment],
            detailDisbursement: projectTracking?.tabs[0]?.detailDisbursement?.map((list: any) => {
                return {
                    ...list,
                    budget: formatCurrencyData(list?.budget || "", 'convert'),
                    paid: formatCurrencyData(list?.paid || "", 'convert'),
                    unpaid: formatCurrencyData(list?.unpaid || "", 'convert'),
                }
            }),
            projectTrack: {
                ...projectTracking?.tabs[0]?.projectTrack,
                detailImages: [...(filteredDetailImages || []), ...dataImage],
                detailFiles: [...(filteredDetailFiles || []), ...dataFile],

            },
            detailProcess: projectTracking?.tabs[0]?.detailProcess?.map((list: any) => ({
                ...list,
                detailFiles: list?.detailFiles?.filter((file: any) => file?.idFile !== 0) || [],
                amount: list?.amount ? formatCurrencyData(list?.amount, 'convert') : null
            })),
            detailProgress: projectTracking?.tabs[0]?.detailProgress?.map((list: any) => {
                return {
                    ...list,
                    fileName: undefined
                }
            }),
            detailActivities: await Promise.all(
                projectTracking?.tabs?.slice(1, projectTracking?.tabs?.length)?.map(async (list: any) => {
                    const detailImagesPromisesActivity = Array.isArray(list?.detailImages)
                        ? list?.detailImages?.map(async (data: any) => {
                            dispatch(setLoading());
                            const formData = new FormData();
                            formData.append('file', data);
                            try {
                                const res = await FilesApi.createFile(formData);
                                if (res.status === 200) {
                                    dispatch(unsetLoading());
                                    return {
                                        idFile: res?.data?.result?.idFile,
                                    };
                                } else {
                                    throw new Error(`Failed to create file. Status: ${res.status}`);
                                }
                            } catch (error) {
                                console.error('Error creating file:', error);
                            }
                        })
                        : [];
                    const detailFilesPromise = Array.isArray(list?.projectTrack?.detailFiles)
                        ? list?.projectTrack?.detailFiles?.filter((list: any) => list?.idFile === undefined).map(async (file: any) => {
                            dispatch(setLoading());
                            const formData = new FormData();
                            formData.append('file', file);
                            try {
                                const res = await FilesApi.createFile(formData);
                                if (res.status === 200) {
                                    return {
                                        idFile: res.data?.result?.idFile
                                    };
                                }
                            } catch (error) {
                                console.error(error);
                            }
                        })
                        : [];
                    const detailImagesResultsActivity =
                        list?.detailImages ? await Promise.all(detailImagesPromisesActivity) : [];
                    const detailFilesResultsActivity =
                        list?.projectTrack?.detailFiles ? await Promise.all(detailFilesPromise) : [];

                    return {
                        ...list,
                        sumAllBudget: formatCurrencyData(list?.sumAllBudget, 'convert') || null,
                        sumAllPaid: formatCurrencyData(list?.sumAllPaid, 'convert') || null,
                        sumAllUnpaid: formatCurrencyData(list?.sumAllUnpaid, 'convert') || null,
                        detailDisbursement: list?.detailDisbursement?.map((data: any) => {
                            return {
                                ...data,
                                budget: formatCurrencyData(data?.budget || "", 'convert'),
                                paid: formatCurrencyData(data?.paid || "", 'convert'),
                                unpaid: formatCurrencyData(data?.unpaid || "", 'convert'),
                            }
                        }),
                        detailProcess: list?.detailProcess?.map((data: any) => ({
                            ...data,
                            detailFiles: data?.detailFiles?.filter((file: any) => file?.idFile !== 0)?.map((file: any) => ({
                                ...file,
                                fileName: undefined
                            })) || undefined,
                            amount: data?.amount ? formatCurrencyData(data?.amount, 'convert') : null
                        })),
                        detailProgress: list?.detailProgress?.map((data: any) => {
                            return {
                                ...data,
                                fileName: undefined,
                            };
                        }),
                        projectTrack: list?.projectTrack
                            ? {
                                ...list?.projectTrack,
                                detailImages:
                                    detailImagesResultsActivity?.length > 0
                                        ? [...(list?.projectTrack?.detailImages || []), ...detailImagesResultsActivity]
                                        : list?.projectTrack?.detailImages || [],
                                detailFiles:
                                    detailFilesResultsActivity?.length > 0
                                        ? [...(list?.projectTrack?.detailImages || []), ...detailFilesResultsActivity]
                                        : list?.projectTrack?.detailFiles || [],
                            }
                            : undefined,

                    };
                })
            ),
        }
        // console.log(condition)
        delete condition?.tabs
        // dispatch(unsetLoading());
        // console.log(condition)
        dispatch(setLoading())
        await ProjectApi.updateTrackingProject(Number(idProject), condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(notificationSwal.success)
                    // swalSuccess(notificationSwal.success || res?.data?.description, 'go', '/auth/project-status',undefined,navigate)
                } else {
                    dispatch(unsetLoading())
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => {
                dispatch(unsetLoading())
                handleGetDetailProject()
            })
    }
    const handleScroll = () => {
        const scrollTop = window.scrollY;
        setIsVisible(scrollTop > 100);
    };
    const handleGetFiscalYear = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleGetStrategy = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear])

    const handleGetTactics = useCallback(async () => {
        let condition: getTactics = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (idStrategy) condition = { ...condition, idStrategy: idStrategy }
        await TacticsApi.getTactics(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setTactics(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear, idStrategy])
    const handleGetPlan = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await PlanApi.getPlans(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setPlans(res.data?.result?.items)

                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetType = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await TypesApi.getType(condition)
            .then(res => {
                if (res.status === 200) {
                    setTypes(res.data?.result?.items);
                    // console.log(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear])
    const handleGetClusters = async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await ClustersApi.getClusters(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setClusters(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetBudgetSource = async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await BudgetApi.getBudgets(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setBudget(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetEmployees = async () => {
        let condition: any = {
        }
        await EmployeesApi.getEmployees(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setEmployees(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetProjectStatus = async () => {
        const condition = {
            idType: idType
        }
        await ProjectApi.getProjectStatus(condition)
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }


    // TRACKING
    const updateTrackingProject = (name: string, newValue: any, mainIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list.projectTrack,
                            [name]: newValue
                        }
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    };

    const updateIndicatorsTrackingProject = (name: string, newValue: any, mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list.projectTrack,
                            detailTrackIndicators: list?.projectTrack?.detailTrackIndicators?.map((indicator: any, dIndex: number) => {
                                if (dIndex === detailIndex) {
                                    return {
                                        ...indicator,
                                        [name]: newValue
                                    };
                                } else {
                                    return {
                                        ...indicator
                                    };
                                }
                            }) || []
                        }
                    };
                } else {
                    return {
                        ...list
                    };
                }
            })
        }));
    };
    const handleUpdateFileTracking = (newValue: any, mainIndex: number) => {
        const newArray = Array.isArray(newValue) ? newValue : [newValue];

        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: (prev?.tabs || []).map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list.projectTrack,
                            detailFiles: [...(list?.projectTrack?.detailFiles || []), ...newArray]
                        }
                    };
                } else {
                    return { ...list };
                }
            })
        }));
    };

    const handleDeleteFileTrackingProject = (mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mIndex === mainIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list?.projectTrack,
                            detailFiles: list?.projectTrack?.detailFiles?.filter((_: any, dIndex: number) => dIndex !== detailIndex)
                        }
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }



    // PROJECT PROCESS
    const onChangeProcessFile = useCallback(async (acceptedFiles: File, mainIndex: number, detailIndex: number, fileIndex: number) => {
        if (acceptedFiles) {
            const formData = new FormData();
            formData.append('file', acceptedFiles)
            await FilesApi.createFile(formData)
                .then(res => {
                    if (res.status === 200) {
                        setProjectTracking((prev: any) => ({
                            ...prev,
                            tabs: prev.tabs?.map((list: any, tabIndex: number) => {
                                if (tabIndex === mainIndex) {
                                    return {
                                        ...list,
                                        detailProcess: list?.detailProcess?.map((detail: any, dIndex: number) => {
                                            if (dIndex === detailIndex) {
                                                return {
                                                    ...detail,
                                                    detailFiles: detail?.detailFiles?.map((file: any, fIndex: number) => {
                                                        if (fileIndex === fIndex) {
                                                            return {
                                                                ...file,
                                                                idFile: res.data?.result?.idFile,
                                                                fileName: res.data?.result?.fileName
                                                            }
                                                        } else {
                                                            return {
                                                                ...file
                                                            }
                                                        }
                                                    })
                                                }
                                            } else {
                                                return {
                                                    ...detail
                                                }
                                            }
                                        })
                                    }
                                } else {
                                    return {
                                        ...list
                                    }
                                }
                            })
                        }))
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            return;
        }
    }, [])

    const handleDeleteProcess = (mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        detailProcess: list?.detailProcess?.filter((detail: any, dIndex: number) => dIndex !== detailIndex)
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleChangeProcess = (name: string, value: any, mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        detailProcess: list?.detailProcess?.map((detail: any, dIndex: number) => {
                            if (dIndex === detailIndex) {
                                return {
                                    ...detail, [name]: value
                                }
                            } else {
                                return { ...detail }
                            }
                        })
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleAddDetailProcess = (event: React.FormEvent) => {
        event.preventDefault();
        const projectStatusCode = projectStatus?.find((list: any) => list?.idStatus === statusId)?.projectStatusCode;
        projectStatusCode && setProjectStatusCode(projectStatusCode)
        let condition: any = {
            idProjectStatus: statusId,
            period: undefined,
            dateDocument: undefined,
            dateStart: undefined,
            dateEnd: undefined,
            dateTransfer: undefined,
            dateInspection: undefined,
            datePetition: undefined,
            dateCheck: undefined,
            amount: undefined,
            remark: undefined,
            modifiedDate: undefined,
            detailFiles: [{
                idFile: 0, fileName: '-'
            }]
        }
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, index: number) => {
                if (index === indexProcessStatus) {
                    return {
                        ...list,
                        detailProcess: [...list?.detailProcess, condition]
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
        setIsCreateStatus(statusId !== 0 && !isCreateStatus)
    }
    const handleAddMoreFile = (mainIndex: number, detailIndex: number) => {
        const newFile = { idFile: 0, fileName: '-' };
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        detailProcess: list?.detailProcess?.map((detail: any, dIndex: number) => {
                            if (detailIndex === dIndex) {
                                return {
                                    ...detail,
                                    detailFiles: [...detail?.detailFiles, newFile]
                                }
                            } else {
                                return {
                                    ...detail
                                }
                            }
                        })
                    }
                } else
                    return {
                        ...list
                    }

            })
        }))
    }
    const handleDeleteRowFile = (mainIndex: number, detailIndex: number, fileIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, index: number) => {
                if (mainIndex === index) {
                    return {
                        ...list,
                        detailProcess: list?.detailProcess?.map((detail: any, dIndex: number) => {
                            if (detailIndex === dIndex) {
                                return {
                                    ...detail,
                                    detailFiles: detail?.detailFiles?.filter((_: any, fIndex: number) => fileIndex !== fIndex)
                                }
                            } else {
                                return {
                                    ...detail
                                }
                            }
                        })
                    }
                } else {
                    return { ...list }
                }
            })
        }))
    }
    const handleDeleteOneFileProcess = (mainIndex: number, detailIndex: number, fileIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        detailProcess: list?.detailProcess?.map((detail: any, dIndex: number) => {
                            if (dIndex === detailIndex) {
                                return {
                                    ...detail,
                                    detailFiles: detail?.detailFiles?.map((file: any, fIndex: number) => {
                                        if (fileIndex === fIndex) {
                                            return {
                                                ...file,
                                                idFile: 0
                                            }
                                        } else {
                                            return {
                                                ...file
                                            }
                                        }
                                    })
                                }
                            } else {
                                return {
                                    ...detail
                                }
                            }
                        })
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }

    // PROJECT PROGRESS
    // const handleChangeDateReport = (value: any, mainIndex: number, detailIndex: number) => {
    //     setProjectTracking((prev: any) => ({
    //         ...prev,
    //         tabs: prev?.tabs?.map((list: any, mIndex: number) => {
    //             if (mainIndex === mIndex) {
    //                 return {
    //                     ...list,
    //                     detailProgress: list?.detailProgress?.map((report: any, dIndex: number) => {
    //                         if (detailIndex === dIndex) {
    //                             return { ...report, dateReport: value }
    //                         } else return report
    //                     })
    //                 }
    //             } else return list
    //         })
    //     }))
    // }
    // const handleUploadFileDetailProgress = useCallback(async (file: File, mainIndex: number, detailIndex: number) => {
    //     try {
    //         if (file) {
    //             dispatch(setLoading())
    //             const formData = new FormData();
    //             formData.append('file', file)
    //             await FilesApi.createFile(formData)
    //                 .then(res => {
    //                     if (res.status === 200) {
    //                         dispatch(unsetLoading())
    //                         setProjectTracking((prev: any) => ({
    //                             ...prev,
    //                             tabs: prev?.tabs?.map((list: any, mIndex: number) => {
    //                                 if (mIndex === mainIndex) {
    //                                     return {
    //                                         ...list,
    //                                         detailProgress: list?.detailProgress?.map((detail: any, dIndex: number) => {
    //                                             if (detailIndex === dIndex) {
    //                                                 return {
    //                                                     ...detail,
    //                                                     idFile: res.data?.result?.idFile,
    //                                                     fileName: res.data?.result?.fileName
    //                                                 }
    //                                             } else {
    //                                                 return {
    //                                                     ...detail
    //                                                 }
    //                                             }
    //                                         })
    //                                     }
    //                                 } else {
    //                                     return {
    //                                         ...list
    //                                     }
    //                                 }
    //                             })
    //                         }))
    //                     }
    //                 })
    //                 .catch(error => {
    //                     dispatch(unsetLoading())
    //                     console.log(error)
    //                 })
    //         } else {
    //             return;
    //         }
    //     } catch (error) {
    //         throw new Error('upload file progress error' + error)
    //     }
    // }, [])
    // const handleDeleteOneFileProgress = (mainIndex: number, detailIndex: number, fileIndex: number) => {
    //     setProjectTracking((prev: any) => ({
    //         ...prev,
    //         tabs: prev?.tabs?.map((list: any, mIndex: number) => {
    //             if (mIndex === mainIndex) {
    //                 return {
    //                     ...list,
    //                     detailProgress: list?.detailProgress?.map((detail: any, dIndex: number) => {
    //                         if (dIndex === detailIndex) {
    //                             return { ...detail, idFile: 0 }
    //                         } else {
    //                             return { ...detail }
    //                         }
    //                     })
    //                 }
    //             } else {
    //                 return { ...list }
    //             }
    //         })
    //     }))
    // }


    // detailDisbursement
    const handleChangeDetailDisbursement = (name: string, value: any, mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, index: number) => {
                if (index === mainIndex) {
                    return {
                        ...list,
                        detailDisbursement: list?.detailDisbursement?.map((data: any, dIndex: number) => {
                            if (detailIndex === dIndex) {
                                return { ...data, [name]: value }
                            } else return data
                        }),
                    }
                } else return list
            })
        }))
    }



    // Tracking Image
    const handleDeleteFileImageTracking = (mainIndex: number, imgIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, tabIndex: number) => {
                if (mainIndex === tabIndex) {
                    return {
                        ...list,
                        detailImages: list?.detailImages?.filter((_: any, fileIndex: number) => fileIndex !== imgIndex)
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleDeleteFileImageTrackingApi = (mainIndex: number, imgIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, tabIndex: number) => {
                if (mainIndex === tabIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list?.projectTrack,
                            detailImages: list?.projectTrack?.detailImages?.filter((_: any, fileIndex: number) => fileIndex !== imgIndex)
                        }
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleChangeFileImage = (newFile: any, mainIndex: number) => {
        const newArray = Array.isArray(newFile) ? newFile : [newFile];
        if (newFile?.length > 0) {
            setProjectTracking((prev: any) => ({
                ...prev,
                tabs: prev?.tabs?.map((list: any, tabIndex: number) => {
                    if (mainIndex === tabIndex) {
                        return {
                            ...list,
                            detailImages: [...(list?.detailImages || []), ...newArray]
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }))
        } else {
            setProjectTracking((prev: any) => ({
                ...prev,
                tabs: prev?.tabs?.map((list: any, tabIndex: number) => {
                    if (mainIndex === tabIndex) {
                        return {
                            ...list,
                            detailImages: [...(list?.detailImages || []), newFile]
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }))
        }
    }

    // BUDGET ALL
    const handleChangeSumBudget = (name: string, value: any, mainIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        [name]: value
                        // sumAllPaid:
                        //     mainIndex === 0 ? prev?.tabs?.reduce((x: any, y: any) => x + y?.sumAllPaid, 0) || "0" :
                        //         list.detailDisbursement?.reduce((x: any, y: any) => x + formatCurrencyData(y?.paid, 'convert'), 0) || "0"
                    }
                } else return list
            })
        }))
    }

    // BUTTON ALL
    const handleCancelProject = async () => {
        // let condition: any = {
        //     ...dataForCancelProject,
        //     isCancel: true
        // }
        Swal.fire({
            title: "คุณต้องการยกเลิกโครงการ?",
            animation: true,
            showCancelButton: true,
            allowEnterKey: true,
            // confirmButtonColor: colors.danger,
            // cancelButtonColor: colors.white,
            confirmButtonColor: colors.themeMainColor,
            cancelButtonColor: colors.danger,
            // customClass: {
            //     cancelButton: "cancel-swal-button",
            // },
            // reverseButtons: true,
            // buttonsStyling: true,
            // cancelButtonText: t("BUTTON.CANCEL"),
            showClass: {
                popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
                `
            },
            hideClass: {
                popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `
            },
            confirmButtonText: "ตกลง",
        }).then(async (result) => {
            if (result.isConfirmed) {
                dispatch(setLoading())
                await ProjectApi.updateCancelTrackingProject(Number(idProject))
                    .then(res => {
                        if (res.status === 200) {
                            swalSuccess(notificationSwal.success, 'go', '/auth/project-status')
                            // swalSuccess(notificationSwal.success, 'reload')
                        }
                    })
                    .catch(error => {
                        throw new Error('error to cancel project', error)
                    }).finally(() => {
                        dispatch(unsetLoading())
                    })
            } else {
            }
        });
    }
    const handleClosedProject = (e: React.FormEvent) => {
        Swal.fire({
            title: "คุณต้องการปิดโครงการ?",
            animation: true,
            showCancelButton: true,
            allowEnterKey: true,
            confirmButtonColor: colors.themeMainColor,
            cancelButtonColor: colors.danger,
            cancelButtonText: t("BUTTON.CANCEL"),
            showClass: {
                popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
                `
            },
            hideClass: {
                popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `
            },
            confirmButtonText: "ตกลง",
        }).then(async (result) => {
            if (result.isConfirmed) {
                dispatch(setLoading())
                await ProjectApi.updateCloseTrackingProject(Number(idProject))
                    .then(res => {
                        if (res.status === 200) {
                            swalSuccess(notificationSwal.success, 'go', '/auth/project-status')
                        }
                    })
                    .catch(error => {
                        throw new Error('error to cancel project', error)
                    }).finally(() => {
                        dispatch(unsetLoading())
                    })

            } else {
            }
        });
    }
    const handleCancelClosedProject = (e: React.FormEvent) => {
        Swal.fire({
            title: "คุณต้องการยกเลิกการปิดโครงการ?",
            animation: true,
            showCancelButton: true,
            allowEnterKey: true,
            confirmButtonColor: colors.themeMainColor,
            cancelButtonColor: colors.danger,
            cancelButtonText: t("BUTTON.CANCEL"),
            showClass: {
                popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
                `
            },
            hideClass: {
                popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `
            },
            confirmButtonText: "ตกลง",
        }).then(async (result) => {
            if (result.isConfirmed) {
                dispatch(setLoading())
                await ProjectApi.updateCancelCloseTrackingProject(Number(idProject))
                    .then(res => {
                        if (res.status === 200) {
                            swalSuccess(notificationSwal.success, 'reload')
                        }
                    })
                    .catch(error => {
                        throw new Error('error to cancel project', error)
                    }).finally(() => {
                        dispatch(unsetLoading())
                    })

            } else {
            }
        });
    }

    // import equipment
    const handleUploadEquipment = async (file: File) => {
        const formData = new FormData();
        formData.append('file', file)
        await ProjectApi.importEquipment(formData)
            .then(res => {
                if (res.status === 200) {
                    console.log(res.data)
                    setFileEquipment([...res.data?.result])
                } else {
                    notiError('เกิดข้อผิดพลาดในการอัพโหลดเอกสาร')
                }
            })
            .catch(error => {
                console.log(error)
                notiError('เกิดข้อผิดพลาดในการอัพโหลดเอกสาร')
            })
    }
    const handleDeleteRowEquipment = (index: number) => {
        const filterDelete: any[] = fileEquipment?.filter((_, detailIndex: number) => index !== detailIndex)
        setFileEquipment(filterDelete)
    }
    const headCells = [
        {
            id: "seq", disablePadding: false, width: 120, align: 'center', label: "ลำดับที่"
        },
        {
            id: "equipmentType", disablePadding: false, align: "left", label: "ประเภทครุภัณฑ์"
        },
        {
            id: "equipmentName", disablePadding: false, align: "left", label: "ชื่อครุภัณฑ์"
        },
        {
            id: "quantity", disablePadding: false, align: "left", label: "จำนวน"
        },
        {
            id: "price", disablePadding: false, align: "left", label: "ราคา"
        },
        {
            id: "remark", disablePadding: false, align: "left", label: "หมายเหตุ"
        },
        {
            id: "COMPONENT", disablePadding: false, align: "left", class: true, width: 70, label: ""
        },
    ];
    const renderData = (objData: any, index: any) => {
        let dIndex = index + 1;
        const { equipmentName, equipmentType, price, quantity, remark, seq } =
            objData;

        const objRenderData = {
            key: dIndex,
            id: seq,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: seq || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: equipmentType || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: equipmentName || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: quantity || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: Number(price || '0').toLocaleString(undefined, { minimumIntegerDigits: 2 }) || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: remark || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: true,
                    component:
                        <div className='cursor-pointer' onClick={() => handleDeleteRowEquipment(index)}>
                            <img src={RouteImage.delete} alt="" />
                        </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const validateStatusCloseProject = (statusPercent: number) => {
        let validateValue: boolean = false;
        // if (idStatus === 600 || idStatus === 1100) {
        //     return validateValue = true
        // } else if (idStatus === 1100 || idStatus === 1000 || idStatus === 1110 || idStatus === 1210) {
        //     return validateValue = true
        // }
        if (statusPercent >= 80) {
            return validateValue = true
        }
        return validateValue;
    }

    useEffect(() => {
        const isActivityStatus = !!types?.find((list: any) => list?.idType === projectTracking?.idType)?.isActivities
        setIsActivity(isActivityStatus)
        const isEquipments = !!types?.find((list: any) => list?.idType === projectTracking?.idType)?.isEquipment
        setIsEquipment(isEquipments)
    }, [projectTracking?.idType, projectTracking, types])
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        handleGetEmployees();
        handleGetDetailProject();
        handleGetFiscalYear();
    }, [])

    useEffect(() => {
        handleGetBudgetSource();
        handleGetPlan();
        handleGetClusters();
        handleGetTactics();
        handleGetType();
        handleGetStrategy();
    }, [idFiscalYear])

    useEffect(() => {
        handleGetProjectStatus();
    }, [projectTracking?.idType])

    useEffect(() => {
        if (!idProject) navigate(-1)
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 200) {
                setStickyActive(true);
            } else {
                setStickyActive(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    useEffect(() => {
        if (detailExtension) {
            const mostDate = detailExtension.map(function (e: any) { return e?.newEndDate; }).sort().reverse()[0]
            setExpansionMostEndDate(mostDate)
        }
    }, [detailExtension]);

    return (
        <styles.ContainerHome>
            {isLoading === true && <Loading />}
            {isCreateStatus &&
                <ModalCustom
                    enableExit={() => setIsCreateStatus(!isCreateStatus)}
                    maxHeight='200px'
                    heading='เพิ่มสถานะโครงการ'
                    component={
                        <div className='mt-3'>
                            <form
                                className='w-full'
                                onSubmit={handleAddDetailProcess}>
                                <main className='w-full flex flex-col gap-2 relative'>
                                    <FilterSelect
                                        heading='สถานะ'
                                        required
                                        value={statusId}
                                        onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setStatusId(Number(e.target.value))}
                                        labelId='STATUS.LABEL'
                                        selectId='STATUS.SELECT'
                                        options={projectStatus && projectStatus?.map((list, i: number) => (
                                            <MenuItem
                                                key={list?.idStatus} value={list?.idStatus}>
                                                {`${i + 1}.${list?.projectStatusName}`}
                                            </MenuItem>
                                        ))}
                                    />
                                </main>
                                <Box
                                    className='flex justify-center items-center mt-4'>
                                    <ButtonContained
                                        disabled={statusId === 0}
                                        sx={{ maxWidth: 105, '&:disabled': { backgroundColor: colors.disabledGray } }}
                                        type='submit'>
                                        <Typography>
                                            {t("BUTTON.SAVE")}
                                        </Typography>
                                    </ButtonContained>
                                </Box>
                            </form>
                        </div>
                    }
                    alignHeader='center'
                />
            }
            <Navbar />
            <styles.MainContainer>
                <Header />
                <styles.Content>
                    <form onSubmit={handleSubmit}>
                        <section className='flex justify-start flex-col md:flex-row md:justify-between gap-2 w-auto'>
                            <span>
                                <Typography className='text-primary' variant='h4'>
                                    {t("ติดตามสถานะโครงการ")}
                                </Typography>
                            </span>
                            {projectTracking && projectTracking?.canUpdateTrack && projectTracking?.statusCode !== 'errors' && !isClosed && (
                                <div
                                    style={{
                                        position: stickyActive ? 'fixed' : 'relative',
                                        top: stickyActive ? 0 : 0,
                                        right: stickyActive ? 0 : 0,
                                        zIndex: 999
                                    }}
                                    className={`w-auto md:w-auto flex ${stickyActive && 'bg-bg_secondary rounded p-4'} gap-2`}>
                                    <ButtonContained
                                        type='submit'
                                    >
                                        <Typography variant='body1'>
                                            {t("BUTTON.SAVE")}
                                        </Typography>
                                    </ButtonContained>
                                </div>
                            )}
                        </section>

                        <section className='mt-2 md:mt-0'>
                            <Typography variant='h5' className='text-danger' >
                                {`(กำหนดงวดที่ 1 วันที่ ${new Date(projectTracking?.projectStartDate).toLocaleDateString('TH-th', { dateStyle: 'medium' })} - 
                                    ${new Date(projectTracking?.projectEndDate).toLocaleDateString('TH-th', { dateStyle: 'medium' })} )`}
                            </Typography>
                        </section>
                        <section className='my-8'>
                            <AlertCustom
                                seq={projectTracking?.statusSeq || 0}
                                text={projectTracking?.statusName}
                                color={statusChecked(projectTracking?.statusPercent)}
                            // color={projectTracking?.statusCode}
                            />
                        </section>
                        {/* <h1>{`${statusChecked(projectTracking?.statusPercent)} : ${projectTracking?.statusPercent}`}</h1> */}

                        {/* INPUT FIELD 👇 */}
                        <section className='flex flex-col gap-5'>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 md:col-span-3'>
                                    <FilterSelect
                                        required
                                        disabled
                                        heading={t("ปีงบประมาณ")}
                                        renderValue={() => fiscalYear && fiscalYear.find((list) => list?.idFiscalYear === projectTracking?.idFiscalYear)?.fiscalYear}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-fiscal-year"
                                        value={"1"}
                                        labelId="label-fiscal-year"
                                        onchange={() => { }}
                                        options={[]}
                                    />
                                </div>
                                <div className='col-span-12 md:col-span-9'>
                                    <FilterSelect
                                        required
                                        disabled
                                        heading={t("ยุทธศาสตร์")}
                                        renderValue={() => strategy && strategy.find((list) => list?.idStrategy === projectTracking?.idStrategy)?.strategyName}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-setStrategy"
                                        value={"1"}
                                        labelId="label-setStrategy"
                                        onchange={() => { }}
                                        options={[]}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 lg:col-span-5'>
                                    <FilterSelect
                                        required
                                        disabled
                                        heading={t("กลยุทธ์")}
                                        renderValue={() => tactics && tactics.find((list) => list?.idTactics === projectTracking?.idTactics)?.tacticsName}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-tacticsId"
                                        value={"1"}
                                        labelId="label-tacticsId"
                                        onchange={() => { }}
                                        options={[]}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-3'>
                                    <FilterSelect
                                        required
                                        disabled
                                        heading={t("แผนงาน")}
                                        renderValue={() => plans && plans.find((list) => list?.idPlan === projectTracking?.idPlan)?.planName}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-plan"
                                        value={"1"}
                                        labelId="label-plan"
                                        onchange={() => { }}
                                        options={[]}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                    <InputDatePicker
                                        required
                                        disabled
                                        inputName='startProject'
                                        inputHeight={42}
                                        dateFormat="DD/MM/YYYY"
                                        key={"START_PROJECT"}
                                        value={projectDetail && moment(projectTracking?.projectStartDate).format('YYYY-MM-DD')}
                                        placeholder={t('ระบุวันเริ่มต้นโครงการ')}
                                        onChange={() => { }}
                                        heading={t("เริ่มต้นโครงการ")}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                    <InputDatePicker
                                        required
                                        disabled
                                        inputName='endProject'
                                        inputHeight={42}
                                        dateFormat="DD/MM/YYYY"
                                        key={"END_PROJECT"}
                                        value={projectDetail && moment(projectTracking?.projectEndDate).format('YYYY-MM-DD')}
                                        placeholder={t('ระบุวันสิ้นสุดโครงการ')}
                                        onChange={() => { }}
                                        heading={t("สิ้นสุดโครงการ")}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12'>
                                    <FilterSelect
                                        required
                                        disabled
                                        heading={t("ชื่อโครงการ")}
                                        renderValue={() => projectTracking && projectTracking?.projectName}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-project-name"
                                        value={"1"}
                                        labelId="label-project-name"
                                        onchange={() => { }}
                                        options={[]}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 lg:col-span-3'>
                                    <FilterSelect
                                        required
                                        disabled
                                        heading={t("ประเภทโครงการ")}
                                        renderValue={() => types && types.find((list) => list?.idType === projectTracking?.idType)?.typeName}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-project-name"
                                        value={"1"}
                                        labelId="label-project-name"
                                        onchange={() => { }}
                                        options={[]}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-4'>
                                    <FilterSelect
                                        required
                                        disabled
                                        heading={t("ประเภทกลุ่มภารกิจ (CLUSTERS)")}
                                        renderValue={() => clusters && clusters.find((list) => list?.idClusters === projectTracking?.idClusters)?.clustersName}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-project-name"
                                        value={"1"}
                                        labelId="label-project-name"
                                        onchange={() => { }}
                                        options={[]}
                                    />
                                </div>
                            </article>
                            <article className="grid grid-cols-12 gap-2">
                                <div className='col-span-12'>
                                    <InputTextField
                                        disablePaddingMultiline
                                        inputHeight={'auto'}
                                        multiline
                                        disabled
                                        row={3}
                                        maxRows={10}
                                        size='medium'
                                        value={projectTracking && projectTracking?.projectDesc}
                                        heading={t("รายละเอียดโครงการ")}
                                    />
                                </div>
                            </article>
                            <article className="grid grid-cols-12 gap-2">
                                <div className='col-span-12'>
                                    <InputTextField
                                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            const value = e.target.value;
                                            setProjectTracking((prev: any) => ({ ...prev, projectPrinciple: value }));
                                        }}
                                        multiline
                                        inputHeight={'auto'}
                                        placeholder='ระบุรายละเอียด'
                                        row={3}
                                        maxRows={10}
                                        disablePaddingMultiline
                                        // disabled
                                        size='medium'
                                        value={projectTracking && projectTracking?.projectPrinciple}
                                        heading={t("หลักการและเหตุผล")}
                                    />
                                </div>
                            </article>
                            {/* ขยายระยะเวลาโครงการ */}
                            {projectDetail
                                // && !projectDetail?.isClosed
                                // projectDetail?.statusPercent === 100 &&
                                && detailExtension?.length > 0
                                && (
                                    <article className='w-full'>
                                        <MainAccordion defaultExpanded>
                                            <TopicAccordion
                                                expandIcon={<Dropdown />}
                                            >
                                                <span className='w-full'>
                                                    <Typography variant='h6'>
                                                        ขยายระยะเวลาโครงการ
                                                    </Typography>
                                                </span>
                                            </TopicAccordion>
                                            {detailExtension && detailExtension?.map((extension, detailIndex: number) => {
                                                return (
                                                    <DetailAccordion sx={{ mt: 1 }} key={detailIndex}>
                                                        <div className="grid grid-cols-12 gap-2">
                                                            <span className='col-span-12 md:col-span-2 lg:col-span-1 self-center'>
                                                                <Typography className="text-primary">
                                                                    {`ครั้งที่ ${detailIndex + 1}`}
                                                                </Typography>
                                                            </span>
                                                            <span className='col-span-12 md:col-span-12 lg:col-span-4'>
                                                                <AutocompleteSelect
                                                                    onChange={() => { }}
                                                                    disabled
                                                                    value={projectStatus?.find((data: any) => data?.idStatus === extension.startFromIdStatus) || null}
                                                                    getOptionLabel={(option) => option?.projectStatusName}
                                                                    labelId='STATUS_AFTER_DATE'
                                                                    options={projectStatus || []}
                                                                    heading='สถานะโครงการเริ่มต้นหลังขยายระยะเวลาโครงการ'
                                                                />
                                                            </span>
                                                            <span className="col-span-12 md:col-span-12 lg:col-span-3">
                                                                <InputDatePicker
                                                                    disabled
                                                                    placeholder='ระบุวันที่'
                                                                    onChange={() => { }}
                                                                    value={extension?.newEndDate}
                                                                    heading='วันสิ้นสุดการขยายระยะเวลาโครงการ'
                                                                />
                                                            </span>
                                                        </div>
                                                    </DetailAccordion>
                                                )
                                            })}
                                        </MainAccordion>


                                    </article>
                                )}


                            <article className='w-full'>
                                {isEquipment && (
                                    <>
                                        {/* อัพโหลดเอกสารครุภัณฑ์ 👇*/}
                                        <section className='w-full mt-2 mb-2'>
                                            <Typography className='text-primary' variant='h5'>
                                                {t("อัพโหลดเอกสารครุภัณฑ์")}
                                            </Typography>
                                        </section>
                                        <section className='mt-2'>
                                            <TableCustom
                                                tableMinWidth={1000}
                                                tableFixedWidth
                                                hidePagination
                                                customScroll
                                                page={1}
                                                pageLimit={5}
                                                sortBy={""}
                                                sortType={"ASC"}
                                                headCells={headCells}
                                                rowCount={1}
                                                rowsData={fileEquipment && fileEquipment?.map((data: any, i: any) => {
                                                    return renderData(data, i)
                                                })}
                                                onSort={() => { }}
                                                setPageLimit={() => { }}
                                                setPage={() => { }}
                                            />
                                        </section>
                                        <section className='mt-2 w-full'>
                                            <UploadFile
                                                formatName='เอกสาร Excel'
                                                heading='เอกสารครุภัณฑ์'
                                                onDrop={(file: any) => {
                                                    const fileData: File = file[0];
                                                    const checkedType: boolean = fileData?.name?.includes(fileTypeEnum.excel1 || fileTypeEnum.excel2)
                                                    if (fileData && checkedType) {
                                                        handleUploadEquipment(fileData)
                                                    } else {
                                                        swalError('รูปแบบไฟล์ไม่ถูกต้อง')
                                                    }

                                                }}
                                                file={null}
                                            />
                                        </section>
                                    </>
                                )}

                            </article>

                            <article className='w-full'>
                                <Box sx={{ width: '100%' }}>
                                    <Box
                                        sx={{ display: isActivity ? 'block' : 'none' }}
                                        className='w-full flex flex-col justify-start items-start gap-2 md:flex-row md:justify-between md:items-end overflow-auto'>
                                        <Tabs
                                            TabIndicatorProps={{ sx: { backgroundColor: colors.white, display: "flex", flexWrap: "wrap" } }}
                                            value={projectTabs}
                                            onChange={handleChangeProjectTabs}
                                            aria-label="project-tabs">
                                            {projectTracking?.tabs?.map((list: any, index: number) => (
                                                <CustomTab label={<Typography>{index === 0 ? "โครงการหลัก" : `กิจกรรม ${index}`}</Typography>} {...projectTabsProps(index)} />
                                            ))}
                                        </Tabs>
                                    </Box>

                                    <div className={`${isActivity ? 'bg-bg_secondary' : ''} mt-2`}>
                                        {projectTracking?.tabs?.map((list: any, index: number) => (
                                            <CustomTabPanel key={index} value={projectTabs} index={index}>
                                                {index !== 0 && (
                                                    <article className='grid grid-cols-12'>
                                                        <span className='col-span-12'>
                                                            <InputTextField
                                                                disabled
                                                                value={list?.projectActivitiesName}
                                                                heading={t("ชื่อกิจกรรม")}
                                                            />
                                                        </span>
                                                    </article>
                                                )}
                                                {/* งวดความคืบหน้าโครงการ 👇 */}
                                                <section className='w-full' >
                                                    <MainAccordion
                                                        defaultExpanded
                                                    >
                                                        <TopicAccordion
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls="panel10-content"
                                                            id="panel10-header"
                                                        >
                                                            <article className='flex items-center justify-between'>
                                                                <span className='flex flex-col'>
                                                                    <LabelCustom
                                                                        variant='h6'
                                                                        isRequired
                                                                        text='งวดความคืบหน้าโครงการ'
                                                                    />
                                                                </span>
                                                            </article>
                                                        </TopicAccordion>
                                                        {list?.detailWorkPeriod?.map((data: any, i: number) => (
                                                            <DetailAccordion>
                                                                <article className='w-full'>
                                                                    <div className='col-span-12 lg:col-span-2'>
                                                                        <LabelCustom
                                                                            className='mt-2'
                                                                            text={t(`งวดที่ ${i + 1} ภายในวันที่`)}
                                                                            variant='body1'
                                                                        />
                                                                    </div>
                                                                </article>
                                                                <article key={i} className="grid grid-cols-12 gap-2 mt-2">
                                                                    <div className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            required={true}
                                                                            key={"START_PROJECT"}
                                                                            value={data?.startDate && moment(data?.startDate).format('YYYY-MM-DD')}
                                                                            placeholder={t('ระบุวันเริ่มต้นโครงการ')}
                                                                            onClear={() => { }}
                                                                            onChange={() => { }}
                                                                            heading={t("เริ่มต้นโครงการ")}
                                                                        />
                                                                    </div>
                                                                    <div className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            required={true}
                                                                            key={"END_PROJECT"}
                                                                            value={data?.endDate && moment(data?.endDate).format('YYYY-MM-DD')}
                                                                            placeholder={t('ระบุวันสิ้นสุดโครงการ')}
                                                                            onClear={() => { }}
                                                                            onChange={() => { }}
                                                                            heading={t("สิ้นสุดโครงการ")}
                                                                        />
                                                                    </div>
                                                                </article>
                                                            </DetailAccordion>
                                                        ))}
                                                    </MainAccordion>
                                                </section>

                                                {/* งวดเบิกจ่าย  👇 */}
                                                <section className='w-full mt-2'>
                                                    <MainAccordion
                                                        defaultExpanded
                                                    >
                                                        <TopicAccordion
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"
                                                        >
                                                            <div className='col-span-12 flex justify-between flex-1'>
                                                                <LabelCustom
                                                                    variant='h6'
                                                                    text='งวดเบิกจ่าย'
                                                                    isRequired
                                                                />
                                                            </div>
                                                        </TopicAccordion>
                                                        <div className={`contents ${isDisbursement ? 'invisible' : 'visible'} duration-100`}>
                                                            {list?.detailDisbursement?.map((data: any, i: number) => (
                                                                <DetailAccordion sx={{ display: 'grid', gridTemplateColumns: "repeat(12, minmax(0, 1fr))" }} key={i} className='grid grid-cols-12 gap-x-2 gap-y-3'>
                                                                    <div className='col-span-12 md:col-span-6 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={data?.endDate && moment(data?.endDate).format('YYYY-MM-DD')}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onChange={() => { }}
                                                                            heading={`งวดที่ ${i + 1} ภายในวันที่`}
                                                                        />
                                                                    </div>
                                                                    {index === 0 && (
                                                                        <div className='col-span-12 md:col-span-6 lg:col-span-2'>
                                                                            <InputTextField
                                                                                disableColor='#FFFAF2'
                                                                                disabled={!projectTracking?.canUpdateTrack}
                                                                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                                    handleChangeDetailDisbursement('budget', formatCurrencyData(e.target.value, 'input'), index, i)
                                                                                }}
                                                                                onblur={() => {
                                                                                    const mainTabsSumAllData = projectTracking?.tabs?.slice(0, 1).reduce((total: any, tab: any) => total + tab.detailDisbursement.reduce((a: any, b: any) => a + formatCurrencyData(b.budget, 'convert'), 0), 0) || 0;
                                                                                    handleChangeSumBudget('sumAllBudget', formatCurrencyData(`${mainTabsSumAllData}`, 'input'), index)
                                                                                }}
                                                                                value={data?.budget}
                                                                                heading={t("งบประมาณรวม (บาท)")}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    <div className='col-span-12 md:col-span-6 lg:col-span-2'>
                                                                        <InputTextField
                                                                            disableColor='#FFEFEE'
                                                                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                                handleChangeDetailDisbursement('paid', formatCurrencyData(e.target.value, 'input'), index, i)
                                                                            }}
                                                                            onblur={() => {
                                                                                // const mainTabsSumAllData = projectTracking?.tabs?.reduce((total: any, tab: any) => total + tab.detailDisbursement.reduce((a: any, b: any) => a + formatCurrencyData(b.paid, 'convert'), 0), 0) || 0;
                                                                                // const activitySumAllData = projectTracking?.tabs[index]?.detailDisbursement?.reduce((x: any, y: any) => x + formatCurrencyData(y?.paid, 'convert'), 0) || 0;
                                                                                // handleChangeSumBudget('sumAllPaid', formatCurrencyData(
                                                                                //     index === 0 ? `${mainTabsSumAllData}` : `${activitySumAllData}`
                                                                                //     , 'input'), index)
                                                                                const mainTabsSumAllData = projectTracking?.tabs?.slice(0, 1).reduce((total: any, tab: any) => total + tab.detailDisbursement.reduce((a: any, b: any) => a + formatCurrencyData(b.paid, 'convert'), 0), 0) || 0;
                                                                                // const activitySumAllData = projectTracking?.tabs[index]?.detailDisbursement?.reduce((x: any, y: any) => x + formatCurrencyData(y?.paid, 'convert'), 0) || 0;
                                                                                handleChangeSumBudget('sumAllPaid', formatCurrencyData(
                                                                                    `${mainTabsSumAllData}`
                                                                                    , 'input'), index)
                                                                            }}
                                                                            disabled={!projectTracking?.canUpdateTrack}
                                                                            value={data?.paid}
                                                                            heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                                        />
                                                                    </div>
                                                                    {index === 0 && (
                                                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                                                            <InputTextField
                                                                                disableColor='#ECF4FC'
                                                                                onblur={() => {
                                                                                    // const mainTabsSumAllData = projectTracking?.tabs?.reduce((total: any, tab: any) => total + tab.detailDisbursement.reduce((a: any, b: any) => a + formatCurrencyData(b.unpaid, 'convert'), 0), 0) || 0;
                                                                                    // const activitySumAllData = projectTracking?.tabs[index]?.detailDisbursement?.reduce((x: any, y: any) => x + formatCurrencyData(y?.unpaid, 'convert'), 0) || 0;
                                                                                    // handleChangeSumBudget('sumAllUnpaid', formatCurrencyData(
                                                                                    //     index === 0 ? `${mainTabsSumAllData}` : `${activitySumAllData}`
                                                                                    //     , 'input'), index)
                                                                                    const mainTabsSumAllData = projectTracking?.tabs?.slice(0, 1).reduce((total: any, tab: any) => total + tab.detailDisbursement.reduce((a: any, b: any) => a + formatCurrencyData(b.unpaid, 'convert'), 0), 0) || 0;
                                                                                    // const activitySumAllData = projectTracking?.tabs[index]?.detailDisbursement?.reduce((x: any, y: any) => x + formatCurrencyData(y?.unpaid, 'convert'), 0) || 0;
                                                                                    handleChangeSumBudget('sumAllUnpaid', formatCurrencyData(
                                                                                        `${mainTabsSumAllData}`
                                                                                        , 'input'), index)
                                                                                }}
                                                                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                                    handleChangeDetailDisbursement('unpaid', formatCurrencyData(e.target.value, 'input'), index, i)
                                                                                }}
                                                                                disabled={!projectTracking?.canUpdateTrack}
                                                                                value={data?.unpaid}
                                                                                heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    <div className='col-span-12 md:col-span-6 lg:col-span-2'></div>
                                                                </DetailAccordion>
                                                            ))}
                                                        </div>
                                                    </MainAccordion>
                                                </section>

                                                {/* แหล่งงบประมาณ  👇 */}
                                                {index === 0 && (
                                                    <MainAccordion
                                                        defaultExpanded
                                                    >
                                                        <TopicAccordion
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"
                                                        >
                                                            <article className='flex items-center justify-between'>
                                                                <LabelCustom
                                                                    variant='h6'
                                                                    text={t("แหล่งงบประมาณ")}
                                                                />
                                                            </article>
                                                        </TopicAccordion>
                                                        <DetailAccordion>
                                                            {list?.detailBudget?.map((data: any, i: number) => (
                                                                <div className='w-full'>
                                                                    <article key={i} className='grid grid-cols-12 mt-2'>
                                                                        <div className='col-span-12 lg:col-span-4'>
                                                                            <FilterSelect
                                                                                required
                                                                                disabled
                                                                                heading={t("แหล่งที่มาของงบประมาณ")}
                                                                                renderValue={() => budget && budget.find((list: any) => data?.idBudget === list?.idBudget)?.budgetName}
                                                                                label={t('STATUS.LABEL')}
                                                                                selectId="select-budget-source"
                                                                                value={"0"}
                                                                                labelId="label-budget-source"
                                                                                onchange={() => { }}
                                                                                options={[]}
                                                                            />
                                                                        </div>
                                                                    </article>
                                                                    <article className='grid grid-cols-12 gap-2 mt-2'>
                                                                        <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                            <InputTextField
                                                                                disabled
                                                                                required
                                                                                value={numberFormat(data?.projectBudget) || "-"}
                                                                                onchange={(e) => { }}
                                                                                heading={t("งบประมาณโครงการ (บาท)")}
                                                                            />
                                                                        </span>
                                                                        <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                            <InputTextField
                                                                                disabled
                                                                                required
                                                                                value={numberFormat(data?.equipmentBudget) || "-"}
                                                                                onchange={() => { }}
                                                                                heading={t("งบประมาณครุภัณฑ์ (บาท)")}
                                                                            />
                                                                        </span>
                                                                        <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                            <InputTextField
                                                                                disabled
                                                                                required
                                                                                value={numberFormat(data?.extraBudget) || "-"}
                                                                                onchange={() => { }}
                                                                                heading={t("เงินโอนเพิ่มงบประมาณ (บาท)")}
                                                                            />
                                                                        </span>
                                                                        <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                            <InputTextField
                                                                                disabled
                                                                                required
                                                                                value={numberFormat(data?.reducedBudget) || "-"}
                                                                                onchange={() => { }}
                                                                                heading={t("เงินโอนลดงบประมาณ (บาท)")}
                                                                            />
                                                                        </span>
                                                                        <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                            <InputTextField
                                                                                disabled
                                                                                disableColor='#FFFAF2'
                                                                                required
                                                                                value={`${numberFormat((Number(data?.projectBudget) + Number(data?.equipmentBudget) + Number(data?.extraBudget)) - Number(data?.reducedBudget))}`}
                                                                                onchange={(e) => { }}
                                                                                heading={t("งบประมาณรวม (บาท)")}
                                                                            />
                                                                        </span>
                                                                    </article>
                                                                    <article className='grid grid-cols-12 gap-2 mt-2'>

                                                                    </article>
                                                                </div>
                                                            ))}
                                                        </DetailAccordion>
                                                    </MainAccordion>
                                                )}

                                                {/* งบประมาณรวม  👇 */}
                                                {index === 0 && (
                                                    <section className='w-full mt-2' >
                                                        <article className='grid grid-cols-12 gap-2 mt-2'>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    // disabled={!projectTracking?.canUpdateTrack}
                                                                    disabled
                                                                    disableColor='#FFFAF2'
                                                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSumBudget('sumAllBudget', formatCurrencyData(e.target.value, 'input'), index)}
                                                                    value={list?.sumAllBudget}
                                                                    heading={t("งบประมาณรวม (บาท)")}
                                                                />
                                                            </span>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    // disabled={!projectTracking?.canUpdateTrack}
                                                                    disableColor='#FFEFEE'
                                                                    disabled
                                                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSumBudget('sumAllPaid', formatCurrencyData(e.target.value, 'input'), index)}
                                                                    value={list?.sumAllPaid}
                                                                    heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                                />
                                                            </span>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    // disabled={!projectTracking?.canUpdateTrack}
                                                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSumBudget('sumAllUnpaid', formatCurrencyData(e.target.value, 'input'), index)}
                                                                    disableColor='#ECF4FC'
                                                                    disabled
                                                                    value={list?.sumAllUnpaid}
                                                                    heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                                />
                                                            </span>
                                                        </article>
                                                    </section>
                                                )}

                                                {/* ผู้รับผิดชอบโครงการ 👇*/}
                                                {list?.detailResponsible?.map((data: any, i: number) => (
                                                    <motion.section
                                                        initial={{ y: -50 }}
                                                        animate={{ y: 0 }}
                                                        transition={{ ease: "backInOut", stiffness: 100 }}
                                                        key={i} className='w-full mt-2'>
                                                        <article className='grid grid-cols-12 gap-2 mt-2'>
                                                            <span className={`${i === 0 ? 'col-span-12 lg:col-span-10' : 'col-span-12 lg:col-span-8'}`}>
                                                                <FilterSelect
                                                                    required
                                                                    disabled
                                                                    heading={i === 0 ? t("ผู้รับผิดชอบโครงการหลัก") : t("ผู้รับผิดชอบโครงการรอง")}
                                                                    renderValue={() =>
                                                                        projectDetail?.mainResponsibleName ? projectDetail?.mainResponsibleName : employees && `${employees.find((list: any) => list?.idEmployee === data?.idEmployee)?.employeeFirstname} ${employees.find((list: any) => list?.idEmployee === data?.idEmployee)?.employeeLastname}`}
                                                                    label={t('STATUS.LABEL')}
                                                                    selectId="select-fiscal-year"
                                                                    value={"-"}
                                                                    labelId="label-fiscal-year"
                                                                    onchange={() => { }}
                                                                    options={[]}
                                                                />
                                                            </span>
                                                            <span className='col-span-6 lg:col-span-2'>
                                                                <InputTextField
                                                                    endAdornment={<p>%</p>}
                                                                    disabled
                                                                    value={numberFormat(Number(data?.percent || "0"), 0) || "-"}
                                                                    heading={t("สัดส่วนที่รับผิดชอบ (%)")}

                                                                />
                                                            </span>
                                                        </article>
                                                    </motion.section>
                                                ))}
                                                <section className='w-full mt-2'>
                                                    <article className='grid grid-cols-12 mt-2'>
                                                        <div className='col-span-12'>
                                                            <InputTextField
                                                                // disablePaddingMultiline
                                                                disabled
                                                                size='medium'
                                                                value={projectDetail && projectDetail?.projectDesc}
                                                                onchange={(e) => { }}
                                                                heading={t("รายละเอียดโครงการ")}
                                                            />
                                                        </div>
                                                    </article>
                                                </section>

                                                {/* สถานะการดำเนินงาน 👇*/}
                                                <section className='w-full mt-2 mb-2'>
                                                    <Typography className='text-primary' variant='h5'>
                                                        {t("สถานะการดำเนินงาน")}
                                                    </Typography>
                                                </section>

                                                {list?.detailProcess?.map((process: any, i: number) => (
                                                    <Accordion
                                                        sx={{ borderRadius: "8px", mt: 2 }}
                                                        defaultExpanded={list?.detailProcess?.length - 1 === i}
                                                        key={i}>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"
                                                        >
                                                            <article className='w-full flex flex-col md:flex-row justify-between'>
                                                                <span>
                                                                    <Typography variant='h6'>{`${i + 1}.${projectStatus?.find((status: any) => status?.idStatus === process.idProjectStatus)?.projectStatusName}`}</Typography>
                                                                </span>
                                                                <span>
                                                                    <Typography>{`บันทึกเมื่อ ${moment(process?.modifiedDate ? process?.modifiedDate : new Date()).format('DD/MM/YYYY เวลา HH.mm.ss น.')} `}</Typography>
                                                                </span>
                                                            </article>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <article className='grid grid-cols-12 gap-3'>
                                                                {
                                                                    // process?.idProjectStatus !== 800 &&
                                                                    process?.idProjectStatus !== 400 &&
                                                                        process?.idProjectStatus !== 710 &&
                                                                        process?.idProjectStatus !== 1000 ?
                                                                        (
                                                                            <span className={`col-span-12 lg:col-span-2`}>
                                                                                <InputDatePicker
                                                                                    required
                                                                                    // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                                    disableStartDate={projectTracking?.projectStartDate}
                                                                                    inputName='startProject'
                                                                                    inputHeight={42}
                                                                                    dateFormat="DD/MM/YYYY"
                                                                                    key={"START_PROJECT"}
                                                                                    value={process.dateStart}
                                                                                    placeholder={t('ระบุวันที่')}
                                                                                    onClear={() => handleChangeProcess('dateStart', '', index, i)}
                                                                                    onChange={(e: any) => handleChangeProcess('dateStart', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                                    heading={t("เมื่อวันที่")}
                                                                                    allowClear
                                                                                />
                                                                            </span>
                                                                        ) : <></>}
                                                                {process?.idProjectStatus === 400 && (
                                                                    <>
                                                                        <span className={`col-span-12 lg:col-span-2`}>
                                                                            <InputDatePicker
                                                                                required
                                                                                // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                                disableStartDate={projectTracking?.projectStartDate}
                                                                                inputName='startProject'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                key={"START_PROJECT"}
                                                                                value={process.dateStart}
                                                                                placeholder={t('ระบุวันที่')}
                                                                                onClear={() => handleChangeProcess('dateStart', '', index, i)}
                                                                                onChange={(e: any) => handleChangeProcess('dateStart', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                                heading={t("เมื่อวันที่")}
                                                                                allowClear
                                                                            />
                                                                        </span>
                                                                        <span className={`col-span-12 lg:col-span-2`}>
                                                                            <InputDatePicker
                                                                                required
                                                                                // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                                disableStartDate={projectTracking?.projectStartDate}
                                                                                inputName='startProject'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                key={"START_PROJECT"}
                                                                                value={process.dateEnd}
                                                                                placeholder={t('วันที่สิ้นสุด')}
                                                                                onClear={() => handleChangeProcess('dateEnd', '', index, i)}
                                                                                onChange={(e: any) => handleChangeProcess('dateEnd', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                                heading={t("สิ้นสุด")}
                                                                                allowClear
                                                                            />
                                                                        </span>
                                                                    </>
                                                                )}
                                                                {process?.idProjectStatus === 710 ? (
                                                                    <>
                                                                        <span className={`col-span-12 lg:col-span-2`}>
                                                                            <InputTextField
                                                                                value={process.period}
                                                                                disabledAutoComplete
                                                                                onkeypress={handleTypingNumber}
                                                                                required
                                                                                heading={'งวดที่'}
                                                                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProcess('period', e.target.value, index, i)}
                                                                            />
                                                                        </span>
                                                                        <span className={`col-span-12 lg:col-span-2`}>
                                                                            <InputDatePicker
                                                                                required
                                                                                // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                                disableStartDate={projectTracking?.projectStartDate}
                                                                                inputName='startProject'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                key={"START_PROJECT"}
                                                                                value={process.dateTransfer}
                                                                                placeholder={t('ระบุวันที่')}
                                                                                onClear={() => handleChangeProcess('dateTransfer', '', index, i)}
                                                                                onChange={(e: any) => handleChangeProcess('dateTransfer', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                                heading={t("วันที่ส่งมอบ")}
                                                                                allowClear
                                                                            />
                                                                        </span>
                                                                        <span className='col-span-12 lg:col-span-2'>
                                                                            <InputDatePicker
                                                                                required
                                                                                // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                                disableStartDate={process.dateStart}
                                                                                inputName='dateInspection'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                key={"START_PROJECT"}
                                                                                value={process.dateInspection}
                                                                                placeholder={t('ระบุวันที่')}
                                                                                onClear={() => handleChangeProcess('dateInspection', '', index, i)}
                                                                                onChange={(e: any) => handleChangeProcess('dateInspection', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                                heading={t("วันที่ตรวจรับ")}
                                                                                allowClear
                                                                            />
                                                                        </span>
                                                                        <span className='col-span-12 lg:col-span-2'>
                                                                            <InputDatePicker
                                                                                required
                                                                                // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                                disableStartDate={process.dateStart}
                                                                                inputName='datePetition'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                key={"START_PROJECT"}
                                                                                value={process.datePetition}
                                                                                placeholder={t('ระบุวันที่')}
                                                                                onClear={() => handleChangeProcess('datePetition', '', index, i)}
                                                                                onChange={(e: any) => handleChangeProcess('datePetition', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                                heading={t("วันที่ส่งตั้งฎีกา")}
                                                                                allowClear
                                                                            />
                                                                        </span>
                                                                    </>
                                                                ) : <></>}
                                                                {process?.idProjectStatus === 1000 && (
                                                                    <span className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            required
                                                                            // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                            disableStartDate={process.datePetition}
                                                                            inputName='dateStart'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.datePetition}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onClear={() => handleChangeProcess('datePetition', '', index, i)}
                                                                            onChange={(e: any) => handleChangeProcess('datePetition', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                            heading={t("วันรับเช็ค")}
                                                                            allowClear
                                                                        />
                                                                    </span>
                                                                )}
                                                                {process?.idProjectStatus === 1010 && (
                                                                    <span className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            required
                                                                            // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                            disableStartDate={process.dateStart}
                                                                            inputName='datePetition'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.datePetition}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onClear={() => handleChangeProcess('datePetition', '', index, i)}
                                                                            onChange={(e: any) => handleChangeProcess('datePetition', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                            heading={t("วันที่จัดทำฎีกา")}
                                                                            allowClear
                                                                        />
                                                                    </span>
                                                                )}
                                                                {process?.idProjectStatus === 900 && (
                                                                    <>
                                                                        <span className='col-span-12 lg:col-span-2'>
                                                                            <InputDatePicker
                                                                                required
                                                                                // disableEndDate={expansionMostEndDate || projectTracking?.projectEndDate}
                                                                                disableStartDate={projectTracking?.projectStartDate}
                                                                                inputName='startProject'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                key={"START_PROJECT"}
                                                                                value={process.dateCheck}
                                                                                placeholder={t('ระบุวันที่')}
                                                                                onClear={() => handleChangeProcess('dateCheck', '', index, i)}
                                                                                onChange={(e: any) => handleChangeProcess('dateCheck', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                                heading={t("วันที่เช็ค")}
                                                                                allowClear
                                                                            />
                                                                        </span>
                                                                        <span className='col-span-12 lg:col-span-2'>
                                                                            <InputTextField
                                                                                required
                                                                                onkeypress={handleTypingNumber}
                                                                                inputHeight={42}
                                                                                key={"AMOUNT_PROJECT"}
                                                                                value={process.amount}
                                                                                placeholder={t('ระบุยอดเงิน')}
                                                                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                                    const value: string = e.target.value
                                                                                    const inputValue = formatCurrencyData(value, 'input')
                                                                                    handleChangeProcess('amount', inputValue, index, i)
                                                                                }}
                                                                                heading={t("ยอดเงิน (บาท)")}
                                                                            />
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </article>
                                                            <article className={`w-full  ${process.isShow ? 'hidden' : ''}`}>
                                                                <InputTextField
                                                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProcess('remark', e.target.value, index, i)}
                                                                    heading={t("หมายเหตุ")}
                                                                    value={process.remark}
                                                                />
                                                            </article>
                                                            <article className={`w-full flex flex-col gap-2 ${process.isShow ? 'hidden' : ''}`}>
                                                                <LabelCustom
                                                                    text='แนบไฟล์'
                                                                />
                                                                {/* {list?.detailFiles?.map((file: any, i: number) => ( */}
                                                                {process?.detailFiles?.length > 0 && (
                                                                    <div>
                                                                        {list?.detailFiles?.map((data: any) => {
                                                                            <span>
                                                                                <h1 className='text-danger'>
                                                                                    <p>{data?.fileName}</p>
                                                                                </h1>
                                                                            </span>
                                                                        })}
                                                                    </div>
                                                                )}

                                                                {process?.detailFiles?.map((file: any, fileIndex: number) => (
                                                                    <div key={fileIndex} className='relative'>
                                                                        <FileDragAndDrop
                                                                            isViewTracking={{
                                                                                objData: file
                                                                            }}
                                                                            index={[index, i, fileIndex]}
                                                                            onDeleteFile={() => handleDeleteOneFileProcess(index, i, fileIndex)}
                                                                            fileName={file?.fileName}
                                                                            fileId={file?.idFile}
                                                                            maxSize={10}
                                                                            onTypeError={handleOnTypeError}
                                                                            onSizeError={handleOnSizeError}
                                                                            dropMessageStyle={{
                                                                                backgroundColor: "#000"
                                                                            }}
                                                                            onUpload={(file) => onChangeProcessFile(file, index, i, fileIndex)}
                                                                        />
                                                                        {fileIndex !== 0 && (
                                                                            <Button
                                                                                onClick={() => handleDeleteRowFile(index, i, fileIndex)}
                                                                                sx={{ position: 'absolute', top: 2, right: 2, padding: 0, minWidth: 0, border: 0 }}
                                                                                variant='outlined' color='error'>
                                                                                <CancelOutlinedIcon className='text-danger' />
                                                                            </Button>
                                                                        )}
                                                                    </div>
                                                                ))}


                                                                <Box className="flex justify-end items-center">
                                                                    <ButtonOutlined
                                                                        onClick={() => handleAddMoreFile(index, i)}
                                                                        startIcon={<img src={RouteImage.addButton} alt="add" />}
                                                                        sx={{ width: "100%", maxWidth: "75px", color: colors.lampang_primary }}
                                                                    >
                                                                        {t("BUTTON.ADD")}
                                                                    </ButtonOutlined>
                                                                </Box>
                                                                <Box className="flex justify-end items-center">
                                                                    <Button
                                                                        onClick={() => handleDeleteProcess(index, i)}
                                                                        endIcon={<img src={RouteImage.delete} alt='delete' />}
                                                                    >
                                                                        <Typography className='text-base_secondary'>
                                                                            {notification.file.deleteStatus}
                                                                        </Typography>
                                                                    </Button>
                                                                </Box>
                                                            </article>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                ))}

                                                {/* Button อัพเดตสถานะโครงการ 👇*/}
                                                <section className='w-full flex gap-3 my-3 justify-end items-center'>
                                                    {projectTracking && projectTracking?.canUpdateTrack && projectTracking?.statusCode !== 'errors' && !isClosed && (
                                                        <>
                                                            <span>
                                                                <ButtonOutlined
                                                                    sx={{
                                                                        '&:disabled': {
                                                                            backgroundColor: colors.disabledGray,
                                                                            color: colors.disabledLightGray,
                                                                            border: 0,
                                                                        }
                                                                    }}
                                                                    disabled={projectTracking?.isCancel}
                                                                    onClick={() => {
                                                                        setIsCreateStatus(!isCreateStatus)
                                                                        setIndexProcessStatus(index)
                                                                    }}
                                                                    startIcon={<img src={RouteImage.addButton} alt="add-icon" />}
                                                                >
                                                                    <Typography className='text-primary'>
                                                                        {t("เพิ่มสถานะถัดไป")}
                                                                    </Typography>
                                                                </ButtonOutlined>
                                                            </span>
                                                            <span>
                                                                <ButtonOutlinedDanger
                                                                    disabled={projectTracking?.isCancel}
                                                                    onClick={handleCancelProject}
                                                                    startIcon={<img src={RouteImage.startDeleteIcons} alt='cancel-project' />}
                                                                    sx={{
                                                                        w: 150, maxWidth: 150,
                                                                        '&:disabled': {
                                                                            backgroundColor: colors.disabledGray,
                                                                            color: colors.disabledLightGray,
                                                                            border: 0,
                                                                        }
                                                                    }}
                                                                >
                                                                    <Typography className='text-danger'>
                                                                        {'ยกเลิกโครงการ'}
                                                                    </Typography>
                                                                </ButtonOutlinedDanger>
                                                            </span>
                                                        </>
                                                    )}
                                                </section>

                                                {/* รายงานความคืบหน้าโครงการ 👇*/}

                                                <section className='w-full'>
                                                    {projectProgress && (
                                                        <>
                                                            <Typography className='text-primary' variant='h5'>
                                                                {"ความคืบหน้าโครงการ"}
                                                            </Typography>
                                                        </>
                                                    )}
                                                    <article className='flex flex-col gap-3 mt-3'>
                                                        {projectProgress && (
                                                            <>
                                                                <section
                                                                    className={`w-full flex flex-col group p-3 mt-8 border-[1px] gap-3 border-light rounded-lg duration-200 shadow-md h-auto`}>
                                                                    <MainAccordion
                                                                        defaultExpanded
                                                                    >
                                                                        <TopicAccordion
                                                                            expandIcon={<img src={RouteImage.downArrow} alt="drop-down" />}
                                                                        >
                                                                            <span>
                                                                                <Typography variant='h6'>
                                                                                    {`ผลสัมฤทธิ์ช่วงที่ ${projectProgress?.seq || ""}`}
                                                                                </Typography>
                                                                            </span>
                                                                        </TopicAccordion>
                                                                        <DetailAccordion>
                                                                            <>
                                                                                <main className='w-full flex gap-3 items-center flex-col md:flex-row'>
                                                                                    <span className='w-full md:max-w-[89px]'>
                                                                                        <InputTextField
                                                                                            disableColor='#FFFAF2'
                                                                                            disabled
                                                                                            inputTextAlign='center'
                                                                                            value={Number(projectProgress?.min).toFixed() || ""}
                                                                                            endAdornment={<div>{"%"}</div>}
                                                                                            heading='ผลสัมฤทธิ์'
                                                                                        />
                                                                                    </span>
                                                                                    <span className='mt-7'>
                                                                                        <Typography>{"ถึง"}</Typography>
                                                                                    </span>
                                                                                    <span className='w-full md:max-w-[89px]'>
                                                                                        <InputTextField
                                                                                            disableColor='#FFFAF2'
                                                                                            disabled
                                                                                            inputTextAlign='center'
                                                                                            value={Number(projectProgress?.max).toFixed() || ""}
                                                                                            endAdornment={<div>{"%"}</div>}
                                                                                            heading='ผลสัมฤทธิ์' />
                                                                                    </span>
                                                                                    <span className='mt-7'>
                                                                                        <Typography>{"="}</Typography>
                                                                                    </span>
                                                                                    <span className='w-full md:max-w-[100px]'>
                                                                                        <InputTextField
                                                                                            disableColor='#ECF4FC'
                                                                                            disabled
                                                                                            inputTextAlign='center'
                                                                                            value={projectProgress?.result || ""}
                                                                                            heading='เกณฑ์คุณภาพ' />
                                                                                    </span>
                                                                                </main>
                                                                                <div className='w-full mt-2'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        onchange={() => { }}
                                                                                        value={projectProgress?.remark || ""}
                                                                                        heading='คำอธิบายเกณฑ์คุณภาพ' />
                                                                                </div>
                                                                            </>
                                                                        </DetailAccordion>
                                                                    </MainAccordion>
                                                                </section>
                                                            </>
                                                        )}


                                                        {projectDetail &&
                                                            <TrackingProcess
                                                                updateIndicatorTrackingProject={updateIndicatorsTrackingProject}
                                                                index={index}
                                                                projectDetail={projectTracking?.tabs[index]}
                                                                updateTrackingProject={updateTrackingProject}
                                                            />
                                                        }

                                                        {/* เอกสาร 👇*/}
                                                        <FileTracking
                                                            index={index}
                                                            deleteFileTracking={handleDeleteFileTrackingProject}
                                                            updateTrackingProject={handleUpdateFileTracking}
                                                            projectTracking={projectTracking?.tabs[index]} />



                                                        {/* รูปภาพ 👇*/}
                                                        <ImageTracking
                                                            handleDeleteImageSelect={handleDeleteFileImageTracking}
                                                            tabIndex={index}
                                                            handleDeleteImageApi={handleDeleteFileImageTrackingApi}
                                                            valueAddFile={projectTracking?.tabs[index]?.detailImages || []}
                                                            valueImage={projectTracking?.tabs[index]?.projectTrack?.detailImages || []}
                                                            headingVariant='h5'
                                                            onChange={handleChangeFileImage}
                                                        />
                                                    </article>
                                                </section>


                                            </CustomTabPanel>
                                        ))}
                                    </div>


                                </Box>
                                {projectTracking?.statusCode !== 'errors' && (
                                    <span className='w-full flex justify-end mt-3 gap-3'>
                                        {validateStatusCloseProject(statusPercent) && !projectTracking?.isClosed && (
                                            <ButtonContained
                                                disabled={projectTracking?.isCancel || projectTracking?.isClosed}
                                                onClick={handleClosedProject} sx={{ maxWidth: 130, backgroundColor: projectTracking?.isClosed && 'red' }}>
                                                <Typography className={`${projectTracking?.isClosed && 'text-white'}`}>
                                                    {projectTracking?.isClosed ? "ปิดโครงการแล้ว" : "ปิดโครงการ"}
                                                </Typography>
                                            </ButtonContained>
                                        )}
                                    </span>
                                )}
                                {projectTracking?.canCancelClosed && !!projectTracking?.isClosed && (
                                    <span className='w-full flex justify-end mt-3 gap-3'>
                                        <ButtonContained onClick={handleCancelClosedProject} sx={{ maxWidth: 220 }} variant='contained'>
                                            <Typography>
                                                ยกเลิกการปิดโครงการ
                                            </Typography>
                                        </ButtonContained>
                                    </span>
                                )}
                            </article>
                        </section>
                    </form>
                </styles.Content>
            </styles.MainContainer >
        </styles.ContainerHome >
    )
}

export default EditTrackingProjectStatus



